import IRoute from 'Shared/Routes/Models/IRoute';

import ShakhSalesRoute from './ShakhSalesRoute/ShakhSalesRoute';

const ShakhSalesRoutes: IRoute[][] = [ShakhSalesRoute];

export default ShakhSalesRoutes;
